module.exports = __webpack_public_path__ + "img/40_38_049_730.706b44a7.jpg";